import { useSuspenseQuery } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useDocumentTags({ documentKey }: { documentKey: string }) {
  return useSuspenseQuery({
    ...apiClient.getDocumentTagsDocumentsKeyTagsGetOptions({
      path: { key: documentKey },
    }),
  })
}
